export default {
    delete_partnumber_title: "Delete Part Numbers",
    delete_partnumber_success_message: "The part number has been deleted",
    delete_partnumber_error_message: "It was not possible to delete the part number",
    delete_partnumber_label: "Are you sure you want to delete the part number?",
}